import userAPI from '../../../../_api/user';

const asyncOldPasswordValidate = async (values) => {
    if (values.old_password){
      try {
        await userAPI.validate({ password: values.old_password });
      } catch (e) {
        throw { 'old_password': e.message };
      }
    }
}

export default asyncOldPasswordValidate;